export default __webpack_public_path__ + "static/media/loader.2122b924.gif";